/**
 * AI Analyst copy: the composer and its Scope, Attach SKUs and Snapshot dialogs.
 * Ported verbatim from VentaHub; wired under `aiAnalyst` in `en.ts`.
 */
export const aiAnalystComposer = {
  inputLabel: 'Ask the AI Analyst',
  placeholder:
    'Ask about sales, ads, stock, payouts… e.g. “Which SKUs lost the most sales week on week, and why?”',
  placeholderQueue: 'Type your next question; it will be sent when this answer ends',
  scope: 'Scope',
  attach: 'Attach',
  attachLabel: 'Attach SKUs',
  snapshot: 'Snapshot',
  deep: 'Deep analysis',
  deepOn: 'Deep analysis: slower and more thorough',
  deepOff: 'Fast answers. Turn on for a deeper investigation.',
  deepOffCost:
    'Fast answers. Turn on for a deeper investigation (uses about {{multiple}}× more of your allowance).',
  stop: 'Stop',
  send: 'Send',
  queue: 'Queue question',
  queueHint: 'Queue: send when this answer ends',
  queued: {
    label: 'Queued question',
    next: 'Next:',
    sendNow: 'Stop and send now',
    remove: 'Remove queued question',
  },
  pins: {
    label: 'Scope',
    remove: 'Remove {{label}}',
  },
  attachments: {
    label: 'Attachments',
    skus_one: '{{count}} SKU',
    skus_other: '{{count}} SKUs',
    removeSkus: 'Remove SKU list',
    about: 'About: {{title}}',
    removePage: 'Remove page',
  },
  includePage: "Include what I'm looking at",
  fields: {
    stores: 'Stores',
    storesPlaceholder: 'All my stores',
    brands: 'Brands',
    brandsPlaceholder: 'All my brands',
    from: 'From',
    to: 'To',
  },
  scopeDialog: {
    title: 'Focus the analyst',
    description:
      'Narrow this conversation to some stores, brands or a period. You can only pick what you already have access to.',
    optionsError:
      'Your stores and brands could not be loaded. Try again in a moment; you can still pick a period.',
    clear: 'Clear',
    done: 'Done',
  },
  snapshotDialog: {
    title: 'Generate a snapshot',
    description:
      'A deep review of sales, advertising, inventory, Buy Box, returns and profitability, with a summary and prioritised insights. It takes a few minutes.',
    focus: 'Anything to focus on? (optional)',
    notify: "Notify me when it's ready",
    cancel: 'Cancel',
    generate: 'Generate',
    prompt: 'Generate a snapshot.',
    promptPeriod: 'Generate a snapshot for {{from}} to {{to}}.',
    openEnd: '…',
    focusSuffix: ' Focus: {{focus}}',
  },
  attachDialog: {
    title: 'Attach SKUs',
    description:
      'Paste SKU or ASIN codes (one per line, or separated by commas), or upload a CSV or text file. The analyst limits its answer to them. Up to {{max}}.',
    codesLabel: 'SKU or ASIN codes',
    codesPlaceholder: 'SKU-001\nSKU-002\nB0ABC12345',
    upload: 'Upload file',
    uploadLabel: 'Upload a CSV or text file',
    found_one: '{{count}} code found',
    found_other: '{{count}} codes found',
    none: 'No codes yet',
    noCodesInFile: 'No SKU or ASIN codes found in {{name}}.',
    unreadable: "That file couldn't be read.",
    cancel: 'Cancel',
    attach: 'Attach',
    attachCount: 'Attach {{count}}',
  },
} as const
